import React from "react";
import styles from "./diccionario.module.css";

export default function DictionaryEntry({ item }) {
  return (
    <article className={styles.card}>
      <div className={styles.head}>
        <h3 className={styles.term}>{item.term}</h3>
        {item.category ? <span className={styles.badge}>{item.category}</span> : null}
      </div>

      <p className={styles.def}>{item.definition}</p>

      {Array.isArray(item.examples) && item.examples.length > 0 && (
        <ul className={styles.examples}>
          {item.examples.map((ex, idx) => (
            <li key={idx}>{ex}</li>
          ))}
        </ul>
      )}

      {Array.isArray(item.tags) && item.tags.length > 0 && (
        <div className={styles.tags}>
          {item.tags.map((t) => (
            <span key={t} className={styles.tag}>#{t}</span>
          ))}
        </div>
      )}
    </article>
  );
}
